import { INewCardsLocalStorage, NEW_CARD_LOCALSTORAGE } from '../types';

export const setNewCardsLocalStorage = (
    newCardLocalStorage: INewCardsLocalStorage
) => {
    localStorage.setItem(NEW_CARD_LOCALSTORAGE, JSON.stringify(newCardLocalStorage));
}
